import * as React from "react";
import { createPortal as reactCreatePortal } from "react-dom";
import { FensterDokumentContext } from "./fensterDokument";

/**
 * Ersatz für `createPortal` aus `react-dom` — für alle Popups, Menüs und
 * Rückfragen, die sich an `document.body` hängen.
 *
 * Steht die Komponente in einem ausgelagerten Browserfenster, landet das
 * Portal im `body` DIESES Fensters. Mit dem Original erschiene die Rückfrage
 * auf dem anderen Bildschirm im Hauptfenster.
 */
export function createPortal(
  children: React.ReactNode,
  container: Element | DocumentFragment,
  key?: string | null,
): React.ReactElement {
  return <PortalWeiche key={key ?? undefined} ziel={container}>{children}</PortalWeiche>;
}

const PortalWeiche: React.FC<{ ziel: Element | DocumentFragment; children: React.ReactNode }> = ({ ziel, children }) => {
  const dok = React.useContext(FensterDokumentContext);
  const wohin = dok && ziel === document.body ? dok.body : ziel;
  return reactCreatePortal(children, wohin);
};
